import { takeLeading, put } from 'redux-saga/effects';
import { replace, push } from 'connected-react-router';

import AccountAPI from 'lib/api/AccountAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import {
  logout,
  EMAIL_LOGIN,
  EMAIL_SIGNUP,
  REQUEST_RESET_PASSWORD,
  RESET_PASSWORD,
  VALIDATE_RESET_FORM,
  UPDATE_PASSWORD,
} from 'store/reducers/accounts';
import { openSnackbar } from 'features/snackbar';

const emailLoginSaga = createRequestSaga(EMAIL_LOGIN, AccountAPI.emailLogin);
const emailSignupSaga = createRequestSaga(EMAIL_SIGNUP, AccountAPI.emailSignup);
const requestResetPasswordSaga = createRequestSaga(
  REQUEST_RESET_PASSWORD,
  AccountAPI.requestResetPassword,
  function* () {
    yield put(openSnackbar('발송되었습니다. 메일함을 확인해주세요.'));
    yield put(push('/accounts/login'));
  },
);
const resetPasswordSaga = createRequestSaga(
  RESET_PASSWORD,
  AccountAPI.resetPassword,
  function* () {
    yield put(openSnackbar('처리되었습니다'));
    yield put(replace('/accounts/login'));
  },
);
const validateResetFormSaga = createRequestSaga(
  VALIDATE_RESET_FORM,
  AccountAPI.validateResetForm,
);
const updatePasswordSaga = createRequestSaga(
  UPDATE_PASSWORD,
  AccountAPI.updatePassword,
  function* () {
    yield put(openSnackbar('변경되었습니다'));
  },
);

const logoutSaga = createRequestSaga(logout, AccountAPI.logout);

export default function* accountsSaga() {
  yield takeLeading(EMAIL_LOGIN, emailLoginSaga);
  yield takeLeading(EMAIL_SIGNUP, emailSignupSaga);
  yield takeLeading(REQUEST_RESET_PASSWORD, requestResetPasswordSaga);
  yield takeLeading(RESET_PASSWORD, resetPasswordSaga);
  yield takeLeading(VALIDATE_RESET_FORM, validateResetFormSaga);
  yield takeLeading(UPDATE_PASSWORD, updatePasswordSaga);
  yield takeLeading(logout, logoutSaga);
}
